import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LoadingComponent } from './components/loading/loading.component';
import { RouterModule } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NumberAnimationComponent } from './components/number-animation/number-animation.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AppLoaderComponent } from './components/app-loader/app-loader.component';
import { AddCashoutsComponent } from './components/modals/add-cashout/add-cashout.component';
import { CashoutConfirmationComponent } from './components/modals/add-cashout/cashout-confirmation/cashout-confirmation.component';
import { AedFormComponent } from './components/modals/add-cashout/currencies/AED/aed-form.component';
import { BtcFormComponent } from './components/modals/add-cashout/currencies/BTC/btc-form.component';
import { CopFormComponent } from './components/modals/add-cashout/currencies/COP/cop-form.component';
import { EthFormComponent } from './components/modals/add-cashout/currencies/ETH/eth-form.component';
import { EurFormComponent } from './components/modals/add-cashout/currencies/EUR/eur-form.component';
import { MxnFormComponent } from './components/modals/add-cashout/currencies/MXN/mxn-form.component';
import { UsdFormComponent } from './components/modals/add-cashout/currencies/USD/usd-form.component';
import { UsdtFormComponent } from './components/modals/add-cashout/currencies/USDT/usdt-form.component';
import { VesFormComponent } from './components/modals/add-cashout/currencies/VES/ves-form.component';
import { LatamNotbankFormComponent } from './components/modals/add-cashout/currencies/LATAM/latam-notbank-form.component';
import { NotbankProvisionDialogComponent } from './components/modals/notbank-provision/notbank-provision-dialog.component';
import { DepaPersonalAccountDialogComponent } from './components/modals/depa-personal-account/depa-personal-account-dialog.component';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { NavbarComponent } from './components/navbar/navbar.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { TitleCasePipe } from './pipes/title-case.pipe';
import { AddVirtualCardComponent } from './components/modals/add-virtual-card/add-virtual-card.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { ViewVirtualCardComponent } from './components/modals/view-virtual-card/view-virtual-card.component';
import { ViewVirtualCardTransactionsComponent } from './components/modals/view-virtual-card-transactions/view-virtual-card-transactions.component';
import { AddCashinComponent } from './components/modals/add-cashin/add-cashin.component';
import { AedCashinFormComponent } from './components/modals/add-cashin/currencies/AED/aed-cashin-form.component';
import { BtcCashinFormComponent } from './components/modals/add-cashin/currencies/BTC/btc-cashin-form.component';
import { CopCashinFormComponent } from './components/modals/add-cashin/currencies/COP/cop-cashin-form.component';
import { EthCashinFormComponent } from './components/modals/add-cashin/currencies/ETH/eth-cashin-form.component';
import { EurCashinFormComponent } from './components/modals/add-cashin/currencies/EUR/eur-cashin-form.component';
import { MxnCashinFormComponent } from './components/modals/add-cashin/currencies/MXN/mxn-cashin-form.component';
import { UsdCashinFormComponent } from './components/modals/add-cashin/currencies/USD/usd-cashin-form.component';
import { UsdtCashinFormComponent } from './components/modals/add-cashin/currencies/USDT/usdt-cashin-form.component';
import { VesCashinFormComponent } from './components/modals/add-cashin/currencies/VES/ves-cashin-form.component';
import { AddPaymentDeclarationComponent } from './components/modals/add-payment-declaration/add-payment-declaration.component';
import { ViewWalletsToDepositComponent } from './components/modals/view-wallets-to-deposit/view-wallets-to-deposit.component';
import { AddInternalComponent } from './components/modals/add-internal/add-internal.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { CreateSupportTicketComponent } from './components/modals/create-support-ticket/create-support-ticket.component';
import { MenuModule } from 'primeng/menu';
import { ExchangeRateCalculatorComponent } from './components/modals/exchange-rate-calculator/exchange-rate-calculator.component';
import { AddExchangeComponent } from './components/modals/add-exchange/add-exchange.component';
import { ForceChangePasswordComponent } from './components/force-change-password/force-change-password.component';
import { PasswordModule } from 'primeng/password';
import { AddUserComponent } from './components/modals/add-user/add-user.component';
import { CheckboxModule } from 'primeng/checkbox';
import { HasPlatformServiceDirective } from './directives/has-platform-service.directive';
import { PayinDepositDetailsComponent } from './components/payin-deposit-details/payin-deposit-details.component';

@NgModule({
  declarations: [
    SidebarComponent,
    LoadingComponent,
    NumberAnimationComponent,
    AppLoaderComponent,
    AddCashoutsComponent,
    CashoutConfirmationComponent,
    AedFormComponent,
    BtcFormComponent,
    CopFormComponent,
    EthFormComponent,
    EurFormComponent,
    MxnFormComponent,
    UsdFormComponent,
    UsdtFormComponent,
    VesFormComponent,
    LatamNotbankFormComponent,
    NotbankProvisionDialogComponent,
    DepaPersonalAccountDialogComponent,
    AddVirtualCardComponent,
    ViewVirtualCardComponent,
    ViewVirtualCardTransactionsComponent,
    AddCashinComponent,
    AedCashinFormComponent,
    BtcCashinFormComponent,
    CopCashinFormComponent,
    EthCashinFormComponent,
    EurCashinFormComponent,
    MxnCashinFormComponent,
    UsdCashinFormComponent,
    UsdtCashinFormComponent,
    VesCashinFormComponent,
    NavbarComponent,
    TitleCasePipe,
    AddPaymentDeclarationComponent,
    ViewWalletsToDepositComponent,
    AddInternalComponent,
    CreateSupportTicketComponent,
    ExchangeRateCalculatorComponent,
    AddExchangeComponent,
    ForceChangePasswordComponent,
    AddUserComponent,
    HasPlatformServiceDirective,
    PayinDepositDetailsComponent,
  ],
  imports: [
    InputSwitchModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ProgressSpinnerModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    ReactiveFormsModule,
    DialogModule,
    TooltipModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    RadioButtonModule,
    TagModule,
    TableModule,
    MenuModule,
    PasswordModule,
    CheckboxModule,
  ],
  providers: [],
  exports: [
    SidebarComponent,
    LoadingComponent,
    NumberAnimationComponent,
    AppLoaderComponent,
    AddCashinComponent,
    AddCashoutsComponent,
    NavbarComponent,
    TitleCasePipe,
    AddVirtualCardComponent,
    AddPaymentDeclarationComponent,
    ViewVirtualCardComponent,
    ViewVirtualCardTransactionsComponent,
    ViewWalletsToDepositComponent,
    AddInternalComponent,
    CreateSupportTicketComponent,
    ExchangeRateCalculatorComponent,
    AddExchangeComponent,
    ForceChangePasswordComponent,
    AddUserComponent,
    HasPlatformServiceDirective,
    PayinDepositDetailsComponent,
    DepaPersonalAccountDialogComponent,
  ],
})
export class SharedModule {}
